// src/components/ForgotPassword.jsx

import React, { useState } from 'react';
import axios from 'axios';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    axios.post('http://127.0.0.1:8000/api/forgot-password', { email })
      .then(res => {
        setMessage('Password reset link sent to your email.');
      })
      .catch(err => {
        const msg = err.response?.data?.message || 'Failed to send reset link.';
        setMessage(msg);
      });

  };

  return (
    <div className="container mt-5 pt-5">
      <h4>Forgot Password</h4>
      <form onSubmit={handleSubmit}>
        <input
          type="email"
          className="form-control mb-2"
          placeholder="Enter your email"
          value={email}
          onChange={e => setEmail(e.target.value)}
        />
        <button type="submit" className="btn btn-primary">Send Reset Link</button>
        {message && <div className="mt-3">{message}</div>}
      </form>
    </div>
  );
};

export default ForgotPassword;
